import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { Conditional } from '@resurs/react-utils'
import { Column, Button } from '@resurs/midas-react'

import { getText } from '../../../../../internal/TextLabels'
import { Countries } from '../../../../../models/countries'

import mitidLogo from '../../../../../assets/img/mitid.png'

const PaymentIdentificationPageDigitalUI = ({
  result,
  bankIdLogo,
  onNext,
  newPageLoading,
}) => (
  <div style={{ display: 'flex', flex: '1 1 100%' }}>
    <Column noPadding col7>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 100%',
          justifyContent: 'center',
          border: '1px solid lightgrey',
          padding: '2rem',
          marginTop: '2rem',
          fontSize: '2rem',
        }}
      >
        <div style={{ display: 'flex' }}>
          <Column noPadding col6>
            {getText('payApply.sign.invoiceAmount')}
          </Column>
          <Column noPadding col6>
            <NumberFormat
              value={result.payment.paymentStatus.totalOrderAmount}
              displayType="text"
              thousandSeparator=" "
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale
              renderText={val => getText('default.currency', val)}
            />
          </Column>
        </div>
      </div>
    </Column>
    <Column noPadding col2 />
    <Column noPadding col2>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            display: 'flex',
            paddingTop: '3rem',
            justifyContent: 'center',
          }}
        >
          <img
            alt="Bank ID"
            style={{
              height: '6rem',
              width: '12rem',
              verticalAlign: 'middle',
            }}
            src={bankIdLogo}
          />
          <Conditional when={result.store.country === Countries.DK}>
            <img
              alt="Bank ID"
              style={{
                height: '6rem',
                width: '12rem',
                verticalAlign: 'middle',
              }}
              src={mitidLogo}
            />
          </Conditional>
        </div>
        <div
          style={{
            display: 'flex',
            paddingTop: '1rem',
            justifyContent: 'center',
          }}
        >
          <Button
            id="invoice-identify-btn"
            type="primary"
            loading={newPageLoading}
            autoFocus
            onClick={e => {
              e.preventDefault()
              onNext()
            }}
          >
            {getText('payApply.identify.button')}
          </Button>
        </div>
      </div>
    </Column>
  </div>
)

PaymentIdentificationPageDigitalUI.propTypes = {
  result: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  bankIdLogo: PropTypes.string,
  newPageLoading: PropTypes.bool.isRequired,
}

PaymentIdentificationPageDigitalUI.defaultProps = {
  bankIdLogo: null,
}

export default PaymentIdentificationPageDigitalUI
